/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
import { MODAL_ID } from '@jira/navigation-apps__atlassian-navigation-ui/src/constants.tsx';
import ButtonMenuItemWithAnalytics from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/button-menu-item-with-analytics/index.tsx';
import { getProjectMenuItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/utils/getProjectMenuItemAnalytics.tsx';
import { useSwitchModals } from '@jira/platform__controllers-switch-modals/src/index.tsx';
import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import { FormattedMessage, defineMessage } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

const browseTemplates = defineMessage({
	id: 'jira.navigation.apps.sidebar-nav4.sidebars.content.projects.browse-templates.ui.browse-templates',

	defaultMessage: 'Browse templates',
	description: 'Label for the browse templates menu item in project sidebar',
});

export const BrowseTemplatesMenuItem = (): React.JSX.Element => {
	const [, { on: openProjectCreateDrawer }] = useSwitchModals(MODAL_ID.PROJECT_CREATE);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const browseTemplatesAnalytics = getProjectMenuItemAnalytics({
		itemId: 'browseTemplates',
	});

	useEffect(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'viewed',
				actionSubject: 'browseTemplateButton',
			}),
		);
	}, [createAnalyticsEvent]);

	return (
		<ButtonMenuItemWithAnalytics
			onClick={openProjectCreateDrawer}
			elemBefore={<AlignTextLeftIcon label="" color="currentColor" />}
			analytics={browseTemplatesAnalytics}
		>
			<FormattedMessage {...browseTemplates} />
		</ButtonMenuItemWithAnalytics>
	);
};
